import {Component, Input, OnInit} from '@angular/core';
import {DeviceParamLirisV3Filter} from "../../../../../../shared/classes/device/type-v3/device-param-liris-v3-filter";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-param-filter',
    templateUrl: './param-filter.component.html',
    styleUrls: ['./param-filter.component.css']
})
export class ParamFilterComponent implements OnInit {


    public currentFilterIndexForEdition: number = null;
    public openChannelSelection = false;
    public filterForm: FormGroup;
    public showFilterForm: boolean = false;
    public modeName = 'Filter';

    @Input('sensorType') sensorType: number = 6;
    @Input('deviceParamLirisV3FilterArray') deviceParamLirisV3FilterArray: DeviceParamLirisV3Filter[];
    @Input('editable') editable: boolean = true;

    constructor(private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.initFilterForm();
        if (this.sensorType === 18) {
          this.openChannelSelection = true;
        }

    }

    initFilterForm() {
        this.showFilterForm = false;
        this.filterForm = new FormGroup({
            activated: new FormControl(true),
            channel: new FormControl(0, [Validators.required]),
            t0: new FormControl('', [Validators.required]),
        });
    }

    addFilter() {
        let filter = new DeviceParamLirisV3Filter();
        if (this.filterForm.valid) {
            filter.activated = this.filterForm.value.activated;
            filter.channel = this.filterForm.value.channel;
            filter.t0 = this.filterForm.value.t0;

            this.toastr.success(this.modeName + ' added', this.translate.instant('SUCCESS'));
            this.deviceParamLirisV3FilterArray.push(filter);
            this.initFilterForm();
        } else {
            this.toastr.error('fill all fields !', this.translate.instant('SUCCESS'));
        }
    }

    editFilter() {
        if (this.filterForm.valid) {
            let i = this.currentFilterIndexForEdition;

            this.deviceParamLirisV3FilterArray[i].activated = this.filterForm.value.activated;
            this.deviceParamLirisV3FilterArray[i].channel = this.filterForm.value.channel;
            this.deviceParamLirisV3FilterArray[i].t0 = this.filterForm.value.t0;


            this.toastr.success(this.modeName + ' #' + this.currentFilterIndexForEdition + ' modified', this.translate.instant('SUCCESS'));
            this.currentFilterIndexForEdition = null;
            this.initFilterForm();

        } else {
            this.toastr.error('fill all fields !', this.translate.instant('ERROR'));
        }
    }

    setFormWithFilter(i: number) {

        this.initFilterForm();
        this.showFilterForm = true;
        this.currentFilterIndexForEdition = i;
        this.filterForm.setValue({
            activated: this.deviceParamLirisV3FilterArray[i].activated,
            channel: this.deviceParamLirisV3FilterArray[i].channel,
            t0: this.deviceParamLirisV3FilterArray[i].t0
        });
        this.toastr.success('You can now edit ' + this.modeName.toLowerCase() + ' #' + this.currentFilterIndexForEdition, this.translate.instant('SUCCESS'));
    }

    cancelFilter() {
        this.currentFilterIndexForEdition = null;
        this.initFilterForm();

    }

    removeFilter(i: number) {
        this.deviceParamLirisV3FilterArray.splice(i, 1);
        this.toastr.warning(this.modeName + ' #' + i + ' removed', this.translate.instant('SUCCESS'));
    }

}
